import Environment from '../../../Environment';
import { IGroupLocation } from '../Types';
import BaseService, {
  IHttpResponse,
  IUri,
  buildUrl,
} from './../../BaseService';

const RESOURCE = 'locations';

interface IGetGroupLocation extends IUri {
  id: string;
  token?: string;
}

interface IGetGroupLocationResponse extends IHttpResponse {
  body?: IGroupLocation;
}

export default async function ({
  token,
  ...buildUrlProps
}: IGetGroupLocation): Promise<IGetGroupLocationResponse> {
  const url = buildUrl({
    host: Environment.groupsHost,
    resource: RESOURCE,
    ...buildUrlProps,
  });

  return BaseService.Get({
    url,
    token,
    skipTimestamp: true,
  });
}
